import { useQuery } from "@tanstack/react-query";

import type { TechnologiesDescriptionDto } from "app/pages/sales-intelligence/domain/technology/types/dto";
import {
    groupTechnologiesByType,
    toGroupedTechnologiesCategoryMap,
} from "app/pages/sales-intelligence/domain/technology/utils/grouping";

import { createDescriptionQuery } from "./options";

const select = ({ technologies }: TechnologiesDescriptionDto) =>
    toGroupedTechnologiesCategoryMap(groupTechnologiesByType(technologies));

export default function useGroupedTechnologiesCategoryMapQuery() {
    return useQuery(
        createDescriptionQuery({
            select,
        }),
    );
}
